<template>
  <div
    :class="`panel ${onPanelClick ? 'cursor-pointer panel--hover' : ''} ${disabled ? 'panel--disabled' : ''} ${heightSizeClass || ''} ${classes}`"
    @click="() => onPanelClick && onPanelClick()"
  >
    <a>
      <div
        v-if="tagIconName"
        v-tooltip.top-center="tagTooltip"
        class="panel-tag"
      >
        <tr-svg-icon
          :name="tagIconName"
        />
      </div>
      <div
        v-if="leftWidgetIconName || $slots['left-widget']"
        :class="`col-sm-3 col-lg-5 panel-widget--left bg-${leftWidgetBgColor}`"
      >
        <slot name="left-widget">
          <tr-svg-icon
            size="medium"
            color="white"
            :name="leftWidgetIconName"
          />
        </slot>
      </div>
      <div class="col-sm-9 col-lg-7 panel-widget--right no-padding-bottom">
        <slot />
      </div>
      <div class="clearfix" />
      <slot name="bands" />
    </a>
  </div>
</template>

<script>
import TrSvgIcon from './TrSvgIcon.vue';

export default {
  name: 'TrPanel',
  components: {
    TrSvgIcon
  },
  props: {
    classes: {
      required: false,
      type: String,
      default: ''
    },
    onPanelClick: {
      required: false,
      type: Function
    },
    tagTooltip: {
      required: false,
      type: String,
      default: ''
    },
    tagIconName: {
      required: false,
      type: String,
      default: ''
    },
    leftWidgetBgColor: {
      required: false,
      type: String,
      default: 'grey'
    },
    leftWidgetIconName: {
      required: false,
      type: String,
      default: ''
    },
    heightSize: {
      required: false,
      type: String,
      default: ''
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    heightSizeClass() {
      if (this.heightSize) {
        return `panel--${this.heightSize}-height`;
      }
      return '';
    }
  }
};
</script>
